const drawer = document.querySelector(".wrapper__nav-drawer");
const nav = document.getElementById("static-header-2");
const menuIcon = document.querySelector(".menu-icon");
const getStarted = document.querySelector("#get-started-header");
const navLinksWrapper = document.querySelector(".wrapper__nav-links");
const pricingWrap = document.querySelector(".wrapper__nav-pricing");
let mobileDrops = document.querySelectorAll(".drop--mobile");
const matchMedia = window.matchMedia(" (max-width: 850px) ");
let drawers = document.querySelectorAll(".drawer");
let navLinks = document.querySelectorAll(".drop--nav");

function openNav(matchMedia) {
  if (!matchMedia.matches) {
    nav.addEventListener("mouseleave", function() {
      removeClasses();
      document.body.classList.remove("nav-open");
    });
  }
  navLinks.forEach(item => {
    if (matchMedia.matches) {
      item.addEventListener("click", event => {
        if (!event.target.parentNode.classList.contains("drop--mobile")) {
          let isMobile = true;
          let drawerID = event.target.parentNode.getAttribute("data-id");
          let currentDrawer = document.getElementById(drawerID);
          openDrawer(currentDrawer, drawer, event, isMobile);

          closeDrawer(currentDrawer, drawer, event);
        }
      });
    } else {
      item.addEventListener("mouseenter", event => {
        if (!event.target.classList.contains("open")) {
          let isMobile = false;
          let drawerID = event.target.getAttribute("data-id");
          let currentDrawer = document.getElementById(drawerID);
          openDrawer(currentDrawer, drawer, event, isMobile);

          closeDrawer(currentDrawer, drawer, event);
        }
      });
    }
  });
}

function removeClasses() {
  drawers.forEach(item => {
    item.classList.remove("active");
  });
  navLinks.forEach(item => {
    item.classList.remove("open");
  });
  drawer.classList.remove("fade-in");
  drawer.classList.remove("open");

  if (nav.classList.contains("nav--index")) {
    nav.classList.remove("open");
  }
}

function closeDrawer(currentDrawer, drawer, event) {
  if (currentDrawer.classList.contains("active")) {
    currentDrawer.classList.remove("active");
    drawer.classList.remove("fade-in");
    drawer.classList.remove("open");
    if (!event.target.parentNode.classList.contains("drop--mobile")) {
      if (nav.classList.contains("nav--index")) {
        nav.classList.remove("open");
      }
    }
    event.target.parentNode.classList.remove("open");
  } else {
    drawers.forEach(item => {
      item.classList.remove("active");
    });
    currentDrawer.classList.add("active");
  }
}

function openDrawer(currentDrawer, drawer, event, isMobile) {
  let eventTarget = isMobile ? event.target.parentNode : event.target;

  drawer.classList.add("open");
  drawer.classList.add("fade-in");
  if (!isMobile) {
    document.body.classList.add("nav-open");
  }

  if (nav.classList.contains("nav--index")) {
    nav.classList.add("open");
  }

  if (eventTarget.classList.contains("open")) {
    eventTarget.classList.remove("open");
  } else if (!isMobile) {
    navLinks.forEach(item => {
      item.classList.remove("open");
    });
    eventTarget.classList.add("open");
  }
}

if (nav) {
  mobileDrops.forEach(item => {
    item.addEventListener("click", event => {
      let drawerID = event.target.parentNode.getAttribute("data-id");
      let currentDrawer = document.querySelector(`#${drawerID}`);

      closeDrawer(currentDrawer, drawer, event);
    });
  });

  menuIcon.addEventListener("click", () => {
    if (menuIcon.classList.contains("active")) {
      menuIcon.classList.remove("active");
      document.body.classList.remove("nav-open");
    } else {
      menuIcon.classList.add("active");
      document.body.classList.add("nav-open");
    }
    removeClasses();
    if (navLinksWrapper.classList.contains("open")) {
      navLinksWrapper.classList.remove("open");
    } else {
      navLinksWrapper.classList.add("open");
    }

    if (pricingWrap.classList.contains("open")) {
      pricingWrap.classList.remove("open");
    } else {
      pricingWrap.classList.add("open");
    }

    if (nav.classList.contains("nav--index")) {
      if (menuIcon.classList.contains("active")) {
        nav.classList.add("open");
      } else {
        nav.classList.remove("open");
      }
    }
  });

  if (
    "IntersectionObserver" in window &&
    "IntersectionObserverEntry" in window &&
    "intersectionRatio" in window.IntersectionObserverEntry.prototype
  ) {
    let observer = new IntersectionObserver(entries => {
      if (entries[0].boundingClientRect.y < 0) {
        removeClasses();
        document.body.classList.remove("nav-open");
        if (getStarted) {
          getStarted.classList.add("active");
        }
      } else {
        if (getStarted) {
          getStarted.classList.remove("active");
        }
      }
    });
    observer.observe(document.querySelector("#nav-stop"));
  }

  openNav(matchMedia);
  matchMedia.addListener(openNav);
}
